<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        
      </div>
      <div class="qualityManagement">
        <div class="hadoop">
          <ul>
            <li class="icon_a"><a href="#/hadoop/beanstalk">Beanstalk企业研发管理平台</a></li>
            <li class="icon_b"><a href="#/hadoop/bigdataPlatform">大数据测试平台</a></li>
            <li class="icon_c"><a href="#/hadoop/agileManagement">敏捷管理咨询</a></li>
            <li class="icon_d actived"><a href="#/hadoop/qualityManagement">质量管理咨询</a></li>
          </ul>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="quality_tab" style="width: 100%;margin: 0 auto;margin-top:105px;  .el-tabs__header{
          width: 1200px !important;
          margin: 0 auto;
          margin-bottom:15px !important;
        }">
          <el-tab-pane label="TMMi咨询认证服务" name="first">
            <div class="share">
              <div style="height:45px;width:415px;margin:0 auto;"><h2>TMMi咨询认证服务</h2></div>
              <span></span>
            </div>
            <div class="qualityManagement-1">
              <div class="view-tip">
                <p class="title">测试管理的挑战与分析</p>
                <div class="detail">
                  <p>当今，随着软件规模和软件复杂度迅速增加，客户的需求也越来越多，加上新型技术（云技术、大数据、移动化、安全）在IT领域的广泛应用，以及企业 对开发、测试、运维的DevOps
                    协同需求，使得高质量，快速测试交付成为一项更加艰巨的工作。面对这样的趋势，越来越多的客户开始重视测试，开始 筹备和建设独立的测试部门，但是他们在建设和运营测试部门
                    的过程当中通常会面临下述挑战：</p>
                  <ul>
                    <li>需求变化越来越频繁，测试交付周期越来越短；</li>
                    <li>需要的测试工程师越来越多，测试成本迅速提升；</li>
                    <li>测试环境资源不足及利用率不高两种现象并存；</li>
                    <li>测试部门如在软件应用的全生命周期发挥更加积极的作用；</li>
                    <li>测试工作的效率和质量如何度量和量化管理。</li>
                  </ul>
                  <p style="margin-top:20px">为了应对上述挑战，很多IT企业开始使用CMMI模型来改善测试管理，然而CMMI模型对测试的关注度不高，测试改进的内容只占CMMI不到10%的篇幅。在这种历史背景下，TMMi 标
                    准于2004年应运而生。</p>
                </div>
              </div>
            </div>
            <div class="qualityManagement-2">
              <div class="view-tip">
                <p class="title">TMMi介绍</p>
                <div class="detail">
                  <p style="margin-top:-10px;margin-bottom:5px">TMMi基金会（一个非营利组织，2004年注册于爱尔兰都柏林）开发了测试成熟度模型集成（TMMi）。它是CMMI的补充模型，是测试过程改进的详细参考。TMMi模型吸收了TMM模
                    型，CMM/CMMI模型，Gelperin和Hetzel的测试过程演进模型的精华，同时参考了IEEE829标准和ISTQB专业软件测试术语。TMMi于2012年传入中国，在国内开始流行和逐步得到认
                    可，目前已经超过20家国内企业的测试部门通过了TMMi3级以上的认证，包括招商银行，交通银行，浦东发展银行，光大银行，太平洋保险等等。TMMi被设计成一个阶段性模型，
                    共分为5个成熟度等级：</p>
                    <div class="qualityimg">
                      <img src="../../../public/hadoopImg/quality1.png" alt="">
                    </div>
                  <p>TMMi 各个成熟度等级特点如下：</p>
                  <p style="width: 1200px;"><span>初始级：</span> &nbsp;&nbsp;&nbsp;测试管理是杂乱无序的，通常测试被认为是调试的一部分，在编码结束自发展开的。缺少资源，工具和受过良好培训的测试员工。产品往往不能按时发布，预
                    <span style="width: 80px;display: inline-block;"></span> 算超支并无法达到预期的交付质量。 </p>
                    <p style="width: 1200px;"><span>已管理级：</span> 测试成为一个已管理的过程，并且明确与调试分开；有全公司或者全项目测试策略以及测试计划，在测试策略中定义了基于产品风险评估的测试途径；测试
                    <span style="width: 84px;display: inline-block;"></span>被有效的监督和控制；测试的设计和执行是根据规格设计和选择的；具有独立的测试环境。 </p>
                    <p><span>已定义级：</span> 测试不再是编码之后的一个阶段，被完全集成到开发生命周期；测试计划在项目前期完成，制定了主测试计划。存在组织级的标准测试过程，并会随着时间
                    <span style="width: 84px;display: inline-block;"></span>推移而改进；拥有独立的测试组织，并有特定的测试培训方案；测试扩大到非功能测试，以及组织认识到评审的重要性。</p>
                    <p><span>已测量级：</span> 测试是一个完全定义，具有良好基础的可测量过程；组织级的测试测量方案会被实施，可以用来评估测试过程的质量，并监督改进；产品质量被用可量化的
                      <span style="width: 84px;display: inline-block;"></span>指标来管理；建立基于数据的同行评审与动态测试之前的协作的测试途径。</p>
                    <p><span>优化级：</span> &nbsp;&nbsp;&nbsp;组织具有基于统计的质量控制能力，具备持续改进的能力，具备缺陷预防的能力 。</p>
                  </div>
              </div>
            </div>
            <div class="qualityManagement-3">
              <div class="view-tip">
                <p class="title">TMMi咨询及认证服务</p>
                <div class="detail">
                  <p>为了满足国内测试组织对于TMMi咨询以及认证需求，功存智能与TMMi基金会合作，得到了TMMi基金会的授权，在国内开展TMMi专业培训，咨询以及认证服</p>
                  <span>1.TMMi专业培训服务：</span>
                  <ul>
                    <li>.TMMi专业培训 （通过TMMi Professional 考试）</li>
                    <li>.TMMi导入式培训</li>
                    <li>.客户定制的TMMi培训</li>
                  </ul>
                </div>
                <div class="detail">
                  <span>2.TMMi测试管理体系建设服务:</span>
                  <ul>
                    <li>.评价客户测试组织目前的测试成熟度水平，进行差距分析</li>
                    <li>.识别测试组织的强项和弱项、改进机会，并协助客户制定规划路线图</li>
                    <li>.依据TMMi模型和最佳实践，制定测试管理体系建设方案</li>
                    <li>.协助客户编写标准测试过程，提供测试管理体系建设落地实施服务</li>
                  </ul>
                </div>
                <div class="detail">
                  <span>3.测试技术和管理平台建设服务：</span>
                  <ul>
                    <li>.基于客户的测试工具和管理平台，进行差距分析</li>
                    <li>.识别出组织在测试技术和工具上的强项和弱项</li>
                    <li>.协助客户制定测试技术和管理平台建设规划路线图</li>
                    <li>.依据最佳实践，制定测试技术和管理平台实施方案</li>
                    <li>.提供测试技术和管理平台落地实施服务</li>
                  </ul>
                </div>
                <div class="detail">
                  <span>4.TMMi评估和认证服务：</span>
                  <ul>
                    <li>.评估准备</li>
                    <li>.预评估</li>
                    <li>.正式评估</li>
                    <li>.获得认证</li>
                  </ul>
                </div>
                <div class="tmmi_img">
                  <img src="../../../public/hadoopImg/tmmi.png" alt="">
                  <p>（功存TMMi认证资质）</p>
                </div>
              </div>
              <div class="view-tip" style="margin-top:-40px">
                <p class="title">对客户的收益</p>
                <div class="detail">
                  <ul class="float_leftul"> 
                    <li>增加客户满意度；</li>
                    <li>提升软件产品的质量;</li>
                    <li>确保及时发布符合市场和客户需求的产品；</li>
                    <li>提升测试组织的成熟度；</li>
                    <li>改进组织管理和提高组织测试成熟度；</li>
                    <li>增强可预测性操作；</li>
                    <li>培养软件质量专家；</li>
                    <li>熟练使用流程改进方法。</li>
                  </ul>
                  <ul class="float_rightul">
                    <li>提供标准化的业务测试流程；</li>
                    <li>降低项目成本，降低5%的开发成本和8%的测试成本；</li>
                    <li>优化组织的测试过程；</li>
                    <li>提高组织对项目的管控；</li>
                    <li>改进整个软件开发生命周期的沟通；</li>
                    <li>精通测试流程；</li>
                    <li>精通软件测试测量体系；</li>
                  </ul>
                </div>
                <div class="detail" style="margin-top:330px">
                  <span>服务报价：</span>
                  <p>服务价格与企业规模、服务实施复杂度、服务周期、服务细项选择等信息相关，咨询与订购TMMi测试过程改进解决方案及认证服务，请致电服务热线：<br>＋86 18601756578</p>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label=" CMMI咨询认证服务" name="second">
            <div class="share">
              <div style="height:45px;width:415px;margin:0 auto;"><h2>CMMI咨询认证服务</h2></div>
              <span></span>
            </div>
            <div class="CMMI_1">
              <div class="view-tip">
                <p class="title">研发管理的挑战与分析</p>
                <div class="detail">
                  <ul>
                    <li>如何能使组织的流程和众多方法论更好地融合?</li>
                    <li>如何让组织的质量管理和监控体系和绩效考评有效结合?</li>
                    <li>如何让开发、测试、运维各有效部门分工、合作能达到最好的效果?</li>
                    <li>如何做好对项目的有效监控、客观评价和横向比较?</li>
                    <li>如何做到供应商选择、评估的客观性和管理的有效性?</li>
                    <li>如何在保证人员能力快速成长的同时保证团队的稳定性?</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="CMMI_2">
              <div class="view-tip">
                <p class="title">CMMI介绍</p>
                <div class="detail">
                  <p>能力成熟度模型集成(The Capability Maturity Model Integration，CMMI®) 是一套世界级的绩效改进框架，用以指引那些在竞争中希望获得高绩效表 现的组织，建立在业务绩效目标
的基础之上，CMMI提供一整套过程改进实践，并最终建立一套绩效改进体系，这套体系为组织更好的运行和实现更高的绩效表现扫清障碍。与其他方法不同的是，CMMI不仅可以帮助
提升组织的过程，而且CMMI内置的实践还能帮助提升组织既有的绩效改进方法，使组织获得良好的投资回报。</p>
                  <div class="cmmi_img">
                    <img src="../../../public/hadoopImg/cmmi.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="CMMI_3">
              <div class="view-tip">
                <p class="title">CMMI咨询及认证服务概述</p>
                <div class="detail">
                  <p>功存智能的CMMI咨询与认证服务包括以下几个阶段：</p>
                  <div class="">
                    <img src="../../../public/hadoopImg/group.png" alt="">
                  </div>
                </div>
              </div>
              <div class="view-tip" style="padding-top:20px">
                <p class="title">对客户的收益</p>
                <div class="detail">
                  <ul class="ul_left">
                    <li>明确组织过程改进规划；</li>
                    <li>结合CMMI咨询与专项咨询，建立组织改进的规划和合理改进方案；</li>
                    <li>提升项目管理的可视性和可控性以及项目绩效管理能力;</li>
                    <li>组织过程成熟度提升；</li>
                    <li>建立完善的质量和开发管理体系，加强组织度量信息和项目经验的积累，提高产品质量和生产率。</li>
                  </ul>
                  <ul class="ul_right">
                    <li>通过差距分析，识别组织成长瓶颈，明确改进方向；</li>
                    <li>更有效的项目和外包管理；</li>
                    <li>规范开发商的选择、监控和评估，降低外包成本和风险;</li>
                    <li>专项咨询完成关键瓶颈能力的迅速提升;</li>
                  </ul>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="质量管理培训服务" name="third">
            <div class="share">
              <div style="height:45px;width:415px;margin:0 auto;"><h2>TMMi Professional课程概述</h2></div>
              <span></span>
            </div>
            <div class="profession_1">
              <div class="view-tip">
                <p style="font-size:17px">本课程是基于TMMi基金会建立的TMMi专业认证考试而设计的培训课程。该课程内容涵盖测试过程改进介绍，TMMi历史介绍，TMMi模型以及TMMi评估。</p>
                <div class="detail">
                  <span>目标学员</span>
                  <ul style="margin-bottom:40px">
                    <li>测试过程改进人员；</li>
                    <li>测试经理；</li>
                    <li>测试咨询师；</li>
                    <li>组织过程成熟度提升；</li>
                    <li>测试过程组成员。</li>
                  </ul>
                  <span>学员收益</span>
                  <ul>
                    <li>系统地掌握测试过程改进相关内容；</li>
                    <li>深入了解TMMi模型；</li>
                    <li>了解TMMi评估过程；</li>
                    <li>通过学习，掌握测试过程改进的能力和方法，为测试团队的过程改进提供指导性意见。</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="profession_2">
              <div class="view-tip">
                <p class="title">课程纲要</p>
                <div class="cur_img">
                  <img src="../../../public/hadoopImg/curriculum.png" alt="">
                </div>
              </div>
            </div>
            <div class="profession_3">
              <div class="view-tip">
                <p class="title">课程天数</p>
                <div class="detail">
                  <p>课程天数：2天 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;培训地点：上海</p>
                </div>
              </div>
              <div class="share">
                <div style="height:45px;width:415px;margin:0 auto;"><h2>测试实战技术培训课程概述</h2></div>
                <span></span>
              </div>
              <div class="view-tip" style="padding-top:0px">
                <div class="detail">
                  <span>目标学员</span>
                  <ul style="margin-bottom:40px">
                    <li>软件测试工程师和质量管理工程师；</li>
                    <li>软件企业的测试主管、测试经理、质量管理经理；</li>
                    <li>其他相关软件项目管理人员和开发人员。</li>
                  </ul>
                  <span>学员收益</span>
                  <ul>
                    <li>系统地掌握软件测试的方法和技术；</li>
                    <li>有效地构建合理的软件测试团队；</li>
                    <li>深入了解和学习惠普的软件测试流程及精髓；</li>
                    <li>了解目前先进的软件测试流程及自动化测试工具；</li>
                    <li>了解测试估算、基于风险的测试、测试过程监控、测试行业价值分析等测试管理过程中比较棘手的问题；</li>
                    <li>了解复杂的综合系统和安全关键系统的测试管理的难点及在实际工作项目中缺陷管理的解决方案；</li>
                    <li>结合软件测试领域的国际标准和能力模型，进行测试过程和测试能力改进，为测试团队的过程改进提供了指导性意见。</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="profession_4">
              <div class="view-tip">
                <p class="title">课程纲要</p>
                <div class="cur_img">
                  <img src="../../../public/hadoopImg/curriculum2.png" alt="">
                </div>
              </div>
            </div>
            <div class="profession_5">
              <div class="view-tip">
                <p class="title">课程天数</p>
                <div class="detail">
                  <p>课程天数：3天 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;培训地点：上海</p>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>       
      </div>
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';
export default {
  components: { navmenu,footerMenu },
  data(){
    return{
      activeName: 'first',
      imgList:[
        {
          name: "banner1",
          title:'大数据及效能',
          detail:'Big data & efficiency',
          src: require("img../../../public/hadoopImg/dashuju1.png"),
        },
      ]
    }
  },
  mounted(){
    if(this.$route.query.title == 'cmmi'){
      this.activeName = 'second'
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/style/public.scss';
@import '~@/assets/style/qualityManagement.scss';  
.share{
  padding:80px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
}

.view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 40px;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: disc;
        margin-left: 18px;
        li{
          // padding-bottom: 5px;
        }
      }
      
    }
  }


.qualityManagement{
  position: relative;
  .hadoop{
    position: absolute;
    width: 1200px;
    height: 150px;
    left:50%;
    transform: translateX(-50%);
    z-index: 99;
    margin-top:-180px ;
    background: url(../../../public/hadoopImg/hadoop.png) center;
    ul{
      margin-top: 60px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      li{height: 40px;line-height: 40px;}
      .icon_a{
        background: url("../../../public/hadoopImg/icon_a.png") no-repeat;
      }
      .icon_a:hover{
        background: url("../../../public/hadoopImg/icon_a1.png") no-repeat;
      }
      .icon_b{
        background: url("../../../public/hadoopImg/icon_b.png") no-repeat;
      }
      .icon_b:hover{
        background: url("../../../public/hadoopImg/icon_b1.png") no-repeat;
      }
      .icon_c{
        background: url("../../../public/hadoopImg/icon_c.png") no-repeat;
      }
      .icon_c:hover{
        background: url("../../../public/hadoopImg/icon_c1.png") no-repeat;
      }
      .icon_d{
        background: url("../../../public/hadoopImg/icon_d.png") no-repeat;
      }
      .actived,.icon_d:hover{
        background: url("../../../public/hadoopImg/icon_d1.png") no-repeat;
      }
      .actived a{color: #01619E;}
      li:hover{
        color: #01619E;
      }
    }
    a{
      color: #333;
      padding-left: 50px;
    }
    a:hover,a:active{
      color: #01619E;
    }
  }
  .el-tabs{    
    .el-tabs__header{
      width: 1340px !important;
      margin: 0 auto;
      margin-bottom: 15px;
    }
  }
  .qualityManagement-1{
    height: 543px;
  }
  .qualityManagement-2{
    height: 1253px;
    background: #F8F9FB;
    .view-tip{
      padding-top: 60px;
      .detail{
        span{
          font-size: 16px;
          line-height: 32px;
        }
      }
      .qualityimg{
        width: 749px;
        height: 466px;
        margin: 0 auto;
        margin-top: 32px;
        margin-bottom: 32px;
      }
    }
  }
  .qualityManagement-3{
    height: 1475px;
    .view-tip{
      padding-top: 60px;
      ul li{
        list-style-type: none;
        background: url(../../../public/hadoopImg/duigou.png) no-repeat left;
        padding-left: 16px;
      }
      .tmmi_img{
        float: right;
        margin-top:-620px;
        margin-right: 260px;
        p{
          color: #666;
          font-size: 16px;
        }
      }
      .float_leftul{
        float: left;
        li{
          list-style-type: disc !important;
          background: none;
          padding-left: 2px;
        }       
      }
      .float_rightul{
        float: right;
        margin-right: 240px;
        li{
          list-style-type: disc !important;
          background: none;
          padding-left: 2px;
        }
      }
    }
  }
  .CMMI_1{
    // height: ;
  }
  .CMMI_2{
    height: 713px;
    background: #F8F9FB;
    .view-tip{
      padding-top: 60px;
    }
    .cmmi_img{
      width: 726px;
      margin: 0 auto;
      margin-top: 32px;
    }
  }
  .CMMI_3{
    height: 962px;
    .view-tip{
      padding-top: 60px;
    }
    .ul_left{
      float: left;
      width: 486px;
    }
    .ul_right{
      float: right;
      margin-right: 60px;
    }
  }
  .profession_2{
    height: 781px;
    background: #F8F9FB;
    .view-tip{
      padding-top: 60px;
      .cur_img{
        margin-top: 32px;
      }
    }
  }
  .profession_3{
    height: 1014px;
    .view-tip{
      padding-top: 60px;
    }
  }
  .profession_4{
    height: 863px;
    background: #F8F9FB;
     .view-tip{
      padding-top: 60px;
      .cur_img{
        margin-top: 32px;
      }
    }
  }
  .profession_5{
    height: 237px;
    .view-tip{
      padding-top: 60px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Hadoop/qualityManagement.vue